import React from 'react'

import { observer } from 'mobx-react-lite'

import { alpha, useTheme } from '@mui/material/styles'

import { useCopyStore, useEvent, usePageview } from '../context/hooks'

import { ANALYTICS_CLICK_EVENTS, ANALYTICS_PAGE_NAMES } from '../constants/Analytics'

import type { MicroInsightCardProps } from '../interfaces'
import MicroCardTemplate from '../MicroCardTemplate'
import { BeatMaterialIcon } from '../beaticons'

export const NoRelevantInsightsCard: React.FC<MicroInsightCardProps> = ({
  ariaLabel,
  elevation,
  heightOverrides,
  onCardClick,
  posthog,
  showIcon,
  variant,
}) => {
  // *************** Context functions *********************git
  const { cardsCopy } = useCopyStore()
  const theme = useTheme()
  const { onEvent } = useEvent()
  const { onPageview } = usePageview()

  // ************** Use Effects Hooks **********************
  React.useEffect(() => {
    onPageview(ANALYTICS_PAGE_NAMES.MICRO_WIDGET_CAROUSEL_NO_RELEVANT_INSIGHTS)
  }, [])

  // *************** Click handlers ************************
  const handleClick = () => {
    if (onCardClick) onCardClick()
    onEvent(ANALYTICS_CLICK_EVENTS.ON_NO_RELEVANT_INSIGHTS_CLICKED)

    posthog?.capture('clicked_insight', {
      template: 'no_relevant_insights',
    })
  }

  return (
    <MicroCardTemplate
      ariaLabel={ariaLabel}
      description={cardsCopy.no_relevant_insights_card_description}
      elevation={elevation}
      heightOverrides={heightOverrides}
      icon={
        showIcon && (
          <BeatMaterialIcon bgColor={alpha(theme.palette.primary.main, 0.15)} name="lightbulb" />
        )
      }
      onCardClick={handleClick}
      onPrimaryAction={handleClick}
      primaryActionText={cardsCopy.micro_card_cta}
      title={cardsCopy.no_relevant_insights_card_title}
      variant={variant}
    />
  )
}

export default observer(NoRelevantInsightsCard)
